var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dx-field-label dinesafe-label"},[_vm._v("Select a payment option")]),_c('div',{ref:"paypalRef",staticClass:"paypal-buttons"}),_c('div',{attrs:{"id":"paypal-button"}})])}
var staticRenderFns = []

export { render, staticRenderFns }